import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { academicVocabularyData, getDataForDifficulty } from './data/skills/reading/academicVocabulary';

export default function AcademicVocabulary() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : academicVocabularyData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
